
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { BusinessItem } from './BusinessItem';
import { Business, businessSchema } from '@/schemas/business'; // Changed to Zod-inferred type
import { getBusinessDisplayName } from './utils/businessUtils'; // This util might need update for Zod type

interface BusinessSelectorTriggerProps {
  business?: Business; // Now Zod Business type
  businessName?: string;
  isMobile?: boolean;
}

export const BusinessSelectorTrigger: React.FC<BusinessSelectorTriggerProps> = ({ 
  business, 
  businessName,
  isMobile = false
}) => {
  // Create a default placeholder that satisfies the Zod schema for Business
  // For required fields like createdAt, updatedAt, provide mock Firestore-like timestamp objects.
  const mockTimestamp = { _seconds: Date.now() / 1000, _nanoseconds: 0 };
  const placeholderBusinessData = {
    id: 'placeholder',
    portfolioId: '',
    name: businessName || 'Select Business',
    status: 'active', // Default status
    createdAt: mockTimestamp,
    updatedAt: mockTimestamp,
    // Add other required fields from businessSchema with default/mock values
    // This ensures the placeholder is a valid Business according to Zod
    displayName: businessName || 'Select Business',
    shortName: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    email: '',
    website: '',
    industry: '',
    // ... any other non-optional fields from businessSchema
  };
  
  // If a full business object is provided, use it.
  // Otherwise, create a minimal placeholder for display purposes,
  // avoiding complex parsing of a full placeholder object.
  const displayBusinessObject = business 
    ? business 
    : ({
        id: 'placeholder-trigger',
        name: businessName || 'Select Business',
        // Add only truly essential fields for BusinessItem if it expects them,
        // or ensure BusinessItem can handle a business object with only id/name.
        // For now, assuming BusinessItem can handle a partial object for display.
      } as Partial<Business>); // Use Partial<Business> if BusinessItem can handle it

  return (
    <DropdownMenuTrigger asChild>
      <div className={`flex items-center justify-between border rounded-md border-gray-200 py-1.5 cursor-pointer hover:bg-gray-50 px-[13px] ${isMobile ? "w-full" : "min-w-[200px] max-w-full"}`}>
        <BusinessItem 
          business={displayBusinessObject as Business} // Cast to Business; ensure BusinessItem is robust
          onClick={() => {}} 
          isMenuItem={false} 
          showLogo={!!displayBusinessObject.logoUrl} // Access logoUrl safely
        />
        <ChevronDown size={16} className="ml-2 text-gray-600" />
      </div>
    </DropdownMenuTrigger>
  );
};
